if (!customElements.get('quick-view-modal')) {
  customElements.define(
    'quick-view-modal',
    class QuickViewModal extends DrawerComponent {
      constructor() {
        super();

        this._classes = {
          loaded: 'quick-view-loaded',
        };
        this.drawerBody = this.querySelector(this.selector);
      }

      get selector() {
        return '.quick-view__content';
      }

      get sourceSelector() {
        return '#MainProduct-quick-view__content';
      }

      get requiresBodyAppended() {
        return !(Shopify.designMode && this.closest('.section-group-overlay-quick-view'));
      }

      shouleBeShow() {
        const sectionId = this.getProductQuickViewSectionId();
        return typeof sectionId === 'string';
      }

      prepareToShow() {
        super.prepareToShow();
        this.quickview();
      }

      handleAfterShow() {
        super.handleAfterShow();
        document.dispatchEvent(
          new CustomEvent('quick-view:open', {
            detail: { productUrl: this.dataset.productUrl },
          })
        );
      }

      handleAfterHide() {
        super.handleAfterHide();
        const drawerContent = this.querySelector(this.selector);
        drawerContent.innerHTML = '';
        this.classList.remove(this._classes.loaded);
      }

      getProductQuickViewSectionId() {
        let sectionId = FoxTheme.QuickViewSectionId || false;

        if (!sectionId) {
          // Get section id from overlay groups.
          const productQuickView = document.querySelector('.section-group-overlay-quick-view');
          if (productQuickView) {
            sectionId = FoxTheme.utils.getSectionId(productQuickView);
          }

          // Cache for better performance.
          FoxTheme.QuickViewSectionId = sectionId;
        }

        return sectionId;
      }

      quickview() {
        const drawerContent = this.querySelector(this.selector);
        const sectionId = this.getProductQuickViewSectionId();
        const productUrl = this.dataset.productUrl;
        const [basePath, existingQuery] = productUrl.split('?');
        const params = new URLSearchParams(existingQuery || '');
        params.set('section_id', sectionId);
        const sectionUrl = `${basePath}?${params.toString()}`;
        fetch(sectionUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const productElement = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector(this.sourceSelector);

            this.setInnerHTML(drawerContent, productElement.content.cloneNode(true));
            FoxTheme.a11y.trapFocus(this, this.focusElement);

            // Galerie auf die gewaehlte Farbe filtern (wie die PDP). Muss hier laufen,
            // nicht im Snippet-JS: die Wishlist injiziert ihre Karten per innerHTML, dabei
            // werden <script> NICHT ausgefuehrt. quick-view.js laeuft dagegen immer.
            this.startColorFilter();

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            setTimeout(() => {
              this.classList.add(this._classes.loaded);
            }, 300);

            document.dispatchEvent(
              new CustomEvent('quick-view:loaded', {
                detail: { productUrl: this.dataset.productUrl },
              })
            );
          })
          .catch((e) => {
            console.error(e);
          });
      }

      setInnerHTML(element, innerHTML) {
        element.innerHTML = '';
        element.appendChild(innerHTML);
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      // Zeigt in der Galerie nur die Bilder der gewaehlten Farbe — repliziert den
      // PDP-Filter (snippets/product-variant-options.liquid -> .product--large), der den
      // Quick-View nicht trifft. Slides matchen ueber ihr custom-alt-Attribut (= die
      // handleisierte Farbe des Bildes, gesetzt in product-thumbnail.liquid). Das an die
      // Variante gebundene Bild hat alt="" -> custom-alt="" und wird damit ausgeblendet.
      filterMediaByColor() {
        const handleize = (t) =>
          (t || '')
            .toString()
            .toLowerCase()
            .trim()
            .replace(/[^\w\s-]/g, '')
            .replace(/[\s_-]+/g, '-')
            .replace(/^-+|-+$/g, '');

        let selected = null;
        const colorInput = this.querySelector(
          'input[name*="Color" i]:checked, input[name*="Farbe" i]:checked'
        );
        if (colorInput) {
          selected = handleize(colorInput.value);
        } else {
          const colorSelect = this.querySelector('select[name*="Color" i], select[name*="Farbe" i]');
          if (colorSelect && colorSelect.value) selected = handleize(colorSelect.value);
        }
        if (!selected) {
          // Sets (seit 29.10.26): keine Farb-Option, Set-Farbe als data-set-color am
          // <variant-selects> (product-variant-picker.liquid), wie filterGallery auf der PDP.
          const setSelects = this.querySelector('variant-selects[data-set-color]');
          if (setSelects) selected = handleize(setSelects.getAttribute('data-set-color'));
        }
        if (!selected) return; // Produkt ohne Farboption -> nicht filtern (wie PDP)

        ['.product__media-item', '.product__thumbs-item'].forEach((sel) => {
          const items = Array.from(this.querySelectorAll(sel));
          if (!items.length) return;
          const wrapper = items[0].parentElement;
          if (!wrapper) return;

          const matched = items.filter((i) => i.getAttribute('custom-alt') === selected);
          if (!matched.length) return; // Sicherheitsnetz: nie die ganze Galerie leeren
          const unmatched = items.filter((i) => matched.indexOf(i) === -1);

          matched.concat(unmatched).forEach((item, index) => {
            item.style.display = matched.indexOf(item) !== -1 ? '' : 'none';
            item.setAttribute('data-swiper-slide-index', index);
            wrapper.appendChild(item); // passende Slides nach vorn holen
          });

          const swiperEl = wrapper.closest('.swiper');
          const swiper = swiperEl && (swiperEl.swiper || swiperEl._swiper);
          if (swiper) {
            try {
              swiper.update();
              swiper.slideTo(0, 0);
            } catch (e) {}
          }
        });
      }

      // Nach dem Laden mehrfach filtern, weil media-gallery.js den Swiper erst nach dem
      // Inject initialisiert (sonst greift swiper.update() ins Leere und der Zaehler
      // bleibt bei der vollen Slide-Zahl stehen).
      startColorFilter() {
        let tries = 0;
        const tick = () => {
          this.filterMediaByColor();
          this.renderGalleryDots();
          if (++tries < 12) setTimeout(tick, 120);
        };
        setTimeout(tick, 80);
      }

      // Klickbare Punkte statt "1 / 6"-Fraction-Zaehler. Baut fuer jeden SICHTBAREN
      // Slide (Farbfilter blendet fremde Farben per display:none aus) einen Dot.
      // Klick springt ueber den echten DOM-Index (nicht den Dot-Index), weil die
      // Slide-Reihenfolge nach dem Filtern nicht der Sichtbaren-Reihenfolge folgt.
      // Laeuft beim Oeffnen 12x -> nur bei geaenderter Anzahl neu aufbauen.
      renderGalleryDots() {
        const el = this.querySelector('.product__media-gallery-viewer');
        const swiper = el && (el.swiper || el._swiper);
        if (!swiper) return;

        const controls = this.querySelector('.slider-controls');
        if (!controls) return;

        let dots = controls.querySelector('.qv-dots');
        if (!dots) {
          dots = document.createElement('div');
          dots.className = 'qv-dots';
          controls.appendChild(dots);
        }

        // Alle Slides in DOM-Reihenfolge; sichtbar = nicht per display:none gefiltert.
        const allItems = Array.from(this.querySelectorAll('.product__media-item'));
        const visible = allItems.filter((i) => getComputedStyle(i).display !== 'none');

        if (visible.length < 2) {
          dots.innerHTML = '';
          return;
        }

        // Aktiven Dot frisch aus dem DOM bestimmen (nicht die aeussere visible-Liste
        // einfangen: nach Farbwechsel sind andere Slides sichtbar).
        const syncActive = () => {
          const curDots = controls.querySelector('.qv-dots');
          if (!curDots) return;
          const curVisible = Array.from(this.querySelectorAll('.product__media-item')).filter(
            (i) => getComputedStyle(i).display !== 'none'
          );
          let activeSlide = null;
          try {
            activeSlide = swiper.slides && swiper.slides[swiper.activeIndex];
          } catch (e) {}
          const activePos = activeSlide ? curVisible.indexOf(activeSlide) : -1;
          Array.from(curDots.children).forEach((dot, i) => {
            const on = i === activePos;
            dot.classList.toggle('is-active', on);
            if (on) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });
        };

        const isDe = (document.documentElement.lang || '').toLowerCase().indexOf('de') === 0;

        // Nur neu aufbauen, wenn sich die sichtbare Anzahl geaendert hat.
        if (dots.children.length !== visible.length) {
          dots.innerHTML = '';
          visible.forEach((slide, i) => {
            const domIndex = allItems.indexOf(slide);
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'qv-dot';
            dot.setAttribute(
              'aria-label',
              isDe ? 'Bild ' + (i + 1) + ' anzeigen' : 'Go to image ' + (i + 1)
            );
            dot.addEventListener('click', () => {
              try {
                swiper.slideTo(domIndex, 400);
              } catch (e) {}
            });
            dots.appendChild(dot);
          });
        }

        // Einmalig auf Swiper-Wechsel hoeren (Flag gegen Mehrfach-Registrierung).
        if (!swiper._qvDotsWired) {
          swiper._qvDotsWired = true;
          try {
            swiper.on('activeIndexChange', syncActive);
          } catch (e) {}
        }

        syncActive();
      }

      disconnectedCallback() {
        super.disconnectedCallback();
        this.handleAfterHide();
      }
    }
  );

  // Farbwechsel im Quick-View -> Galerie neu auf die neue Farbe filtern.
  document.addEventListener('change', function (e) {
    const t = e.target;
    if (!t || !t.name || !/color|farbe/i.test(t.name) || !t.closest) return;
    const modal = t.closest('quick-view-modal');
    if (modal && typeof modal.filterMediaByColor === 'function') {
      setTimeout(function () {
        modal.filterMediaByColor();
        if (typeof modal.renderGalleryDots === 'function') {
          modal.renderGalleryDots();
        }
      }, 60);
    }
  });
}
